import React from "react";
import "../../../styles/main.css";

import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";
import Subpage_102_beta from "../../../modules/caneva/Subpage_102_beta";



const Page_102_beta = () => {
  return (
    <div
      style={{
        padding: 0,
        margin: 0,
        boxSizing: "border-box",
        minWidth: "calc(100vh - 290px)",   // largeur logique de page
        height:"100vh",
        
      }}
    >
      <Breadcrumb
        items={[
          { label: "homepage", href: "/Homepage" },
          { label: "caneva / builder beta", href: "/page_102" },
        ]}
      />

      
      <main
        className="content"
        style={{
          padding: 0,
          margin: 0,
          background: "transparent",
          boxSizing: "border-box",
        }}
      >
        <Subpage_102_beta />
      </main>
    </div>
  );
};

export default Page_102_beta;
